export default __webpack_public_path__ + "media/images/mailer/icon_email-e45d393773eb534a04c40c97fb7ceb18.png";